module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        原料单位管理\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      staticStyle: {
        "height": "9%"
      }
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center"
    }, [_c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right ss flex flex-align-center flex-pack-center"
    }), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("原料单位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDiscount.name),
      expression: "newDiscount.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newDiscount.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDiscount, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "优惠商品详情",
      "visible": _vm.mealInfo,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.mealInfo = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "meal-goods"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('table', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("所属分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.mealInfoData.length) ? _c('table', _vm._l((_vm.mealInfoData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.setMealQty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%",
        "color": "#3068ff",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.delMealGoods(item)
        }
      }
    }, [_vm._v("删除")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.mealInfoData.length) ? _c('div', {
    staticStyle: {
      "padding": "10px 0",
      "text-align": "center"
    }
  }, [_vm._v("\n                            暂无商品\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.showSelGoods) ? _c('div', {
    staticClass: "sel-goods"
  }, [_c('selGoods', {
    attrs: {
      "isDiscount": true,
      "nowSelClassGoods": _vm.nowSelClassGoods,
      "storeId": _vm.curStoreId,
      "nowSelClass": _vm.nowSelClass
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": _vm.closeSelGoods
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8bcbce6e","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/material/matUnit.vue
// module id = 969
// module chunks = 1